export default "__VITE_ASSET__BPBg3up4__"